<template>
  <div>
    <vx-card class="mb-4">
      <div class="flex justify-between items-start flex-wrap gap-2">
        <div>
          <h4 class="mb-1">{{ $t('commission.title') }}</h4>
          <small class="text-muted">{{ $t('commission.hint') }}</small>
        </div>
        <b-form-select v-model="filterStatus" :options="statusFilters" size="sm" style="width: 220px" @change="load"/>
      </div>
    </vx-card>

    <vx-card>
      <div v-if="isLoading" class="text-center py-4 text-muted">{{ $t('common.loading') }}</div>
      <div v-else-if="!rows.length" class="text-muted">{{ $t('commission.empty') }}</div>

      <table v-else class="w-full admin-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t('commission.influencer') }}</th>
            <th>{{ $t('campaign.title') }}</th>
            <th class="text-right">{{ $t('commission.base') }}</th>
            <th class="text-right">{{ $t('commission.discount') }}</th>
            <th class="text-right">{{ $t('commission.amount') }}</th>
            <th>{{ $t('commission.hold_until') }}</th>
            <th>{{ $t('status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="c in rows" :key="c.id">
            <td>{{ c.id }}</td>
            <td>
              {{ _.get(c, 'influencer.name') }}
              <small class="text-muted d-block">{{ $t('commission.order') }} #{{ c.order_id }}</small>
            </td>
            <td>{{ _.get(c, 'campaign.name') }}</td>
            <td class="text-right">{{ money(c.base_amount_cents) }}</td>
            <td class="text-right text-muted">- {{ money(c.discount_amount_cents) }}</td>
            <td class="text-right"><strong>{{ money(c.commission_amount_cents) }}</strong></td>
            <td>
              <span v-if="c.hold_until">{{ formatDate(c.hold_until) }}</span>
              <span v-else class="text-muted">—</span>
            </td>
            <td>
              <vs-chip transparent :color="statusColor(c.status)">
                {{ $t(`commission.status_.${c.status}`) }}
              </vs-chip>
              <small v-if="c.adjustment_reason" class="text-danger d-block">{{ c.adjustment_reason }}</small>
            </td>
          </tr>
        </tbody>
      </table>
    </vx-card>
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'
import WalletAdminService from '@/services/api/WalletAdminService'

export default {
  components: { BFormSelect },
  data: () => ({ service: null, rows: [], isLoading: false, filterStatus: '' }),
  computed: {
    statusFilters() {
      return [
        { text: this.$t('commission.filter_all'), value: '' },
        { text: this.$t('commission.status_.HO'), value: 'HO' },
        { text: this.$t('commission.status_.RE'), value: 'RE' },
        { text: this.$t('commission.status_.ES'), value: 'ES' },
        { text: this.$t('commission.status_.CA'), value: 'CA' },
        { text: this.$t('commission.status_.RJ'), value: 'RJ' }
      ]
    }
  },
  methods: {
    money(cents) {
      return (Number(cents || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatDate(v) { return v ? new Date(v).toLocaleDateString('pt-BR') : '' },
    statusColor(status) {
      switch (status) {
        case 'RE': return 'success'
        case 'HO': return 'warning'
        case 'ES': case 'CA': case 'RJ': return 'danger'
        default: return 'dark'
      }
    },
    load() {
      this.isLoading = true
      const params = this.filterStatus ? { status: this.filterStatus } : {}
      this.service.commissions(params).then(
        r => { this.rows = r.data || [] },
        () => { this.rows = [] }
      ).finally(() => { this.isLoading = false })
    }
  },
  beforeMount() { this.service = WalletAdminService.build(this.$vs) },
  mounted() { this.load() }
}
</script>

<style scoped>
.admin-table th { font-size: 0.75rem; opacity: 0.7; text-align: left; padding-bottom: 0.35rem; }
.admin-table td { padding: 0.55rem 0.4rem; border-top: 1px solid rgba(0,0,0,0.06); vertical-align: top; }
.text-right { text-align: right; }
</style>
